// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueRouter from 'vue-router'
import router from './router'
import MainContainer from './containers/mainContainer'
import VueJsModal from 'vue-js-modal'
Vue.use(VueJsModal, { dialog: true })
import {
	Carousel,
	CarouselItem,
	Dropdown,
    DropdownMenu,
    DropdownItem,
	Pagination,
	Dialog,
	Autocomplete,
	MenuItemGroup,
	Input,
	InputNumber,
	Radio,
	RadioGroup,
	RadioButton,
	Checkbox,
	CheckboxButton,
	CheckboxGroup,
	Select,
	Switch,
	Option,
	OptionGroup,
	Button,
	ButtonGroup,
	Table,
	TableColumn,
	DatePicker,
	TimeSelect,
	TimePicker,
	Popover,
	Tooltip,
	Form,
	FormItem,
	Tabs,
	TabPane,
	Tree,
	Alert,
	Icon,
	Row,
	Col,
	Upload,
	Progress,
	Collapse,
	CollapseItem,
	Cascader,
	ColorPicker,
	Transfer,
	Container,
	Header,
	Aside,
	Main,
	Footer,
	Loading,
	MessageBox,
	Message,
	Notification
  } from 'element-ui';
  
  Vue.use(Pagination);
  Vue.use(Dropdown)
  Vue.use(DropdownMenu)
  Vue.use(DropdownItem)
  Vue.use(Dialog);
  Vue.use(Autocomplete);
  Vue.use(Input);
  Vue.use(InputNumber);
  Vue.use(Radio);
  Vue.use(RadioGroup);
  Vue.use(RadioButton);
  Vue.use(Checkbox);
  Vue.use(CheckboxButton);
  Vue.use(CheckboxGroup);
  Vue.use(Select);
  Vue.use(Switch);
  Vue.use(Option);
  Vue.use(OptionGroup);
  Vue.use(Button);
  Vue.use(ButtonGroup);
  Vue.use(Table);
  Vue.use(TableColumn);
  Vue.use(DatePicker);
  Vue.use(TimeSelect);
  Vue.use(Carousel);
  Vue.use(CarouselItem)
  Vue.use(TimePicker);
  Vue.use(Popover);
  Vue.use(Tooltip);
  Vue.use(Form);
  Vue.use(FormItem);
  Vue.use(Tabs);
  Vue.use(TabPane);
  Vue.use(Tree);
  Vue.use(Alert);
  Vue.use(Icon);
  Vue.use(Row);
  Vue.use(Col);
  Vue.use(Upload);
  Vue.use(Progress);
  Vue.use(Collapse);
  Vue.use(CollapseItem);
  Vue.use(Cascader);
  Vue.use(ColorPicker);
  Vue.use(Container);
  Vue.use(Header);
  Vue.use(Aside);
  Vue.use(Main);
  Vue.use(Footer);
  Vue.use(Loading.directive)
  Vue.prototype.$loading = Loading.service
  Vue.prototype.$msgbox = MessageBox
  Vue.prototype.$alert = MessageBox.alert
  Vue.prototype.$confirm = MessageBox.confirm
  Vue.prototype.$prompt = MessageBox.prompt
  Vue.prototype.$message = Message
  Vue.prototype.$notify = Notification; 
// import style reset
import './style/reset.css'
// import style common
import './style/common.css'
import './style/form_common.less'
// import elementUI
// import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-default/index.css'

// import axios
import axios from 'axios'

// import utils
import api from './utils/http'
import utils from './utils/utils'
// import tool from './utils/tool'
// Vue.use(tool)

import '@/style/style_step_five.less'

import store from '@/stores/index'
import http  from './utils/http'
Vue.prototype.$post=http.post;     
Vue.config.productionTip = false 

Vue.prototype.clone = function clone(obj) {
	let o
	if (typeof obj == 'object') {
		if (obj === null) {
			o = null
		} else {
			if (obj instanceof Array) {
				o = [];
				for (var i = 0, len = obj.length; i < len; i++) {
					o.push(clone(obj[i]))
				}
			} else {
				o = {}
				for (var j in obj) {
					o[j] = clone(obj[j])
				}
			}
		}
	} else {
		o = obj
	}
	return o

}


// Vue.use(ElementUI)

utils.router = router

/* eslint-disable no-new */


new Vue({
  el:'#app',
  template:'<main-container></main-container>',
  store,
  router,
  components:{MainContainer}
})



// WEBPACK FOOTER //
// ./src/main.js